document.addEventListener('DOMContentLoaded', function () {
  var cookieBar = document.getElementById('tp_cookie');
  if (!cookieBar) return;

  var STORAGE_KEY = 'tp_cookie_dismissed';
  var dismissBtn = document.getElementById('ba-cookie-dismiss');

  function hasDismissed() {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      return document.cookie.indexOf(STORAGE_KEY + '=true') !== -1;
    }
  }

  function setDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch (e) {
      var expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      document.cookie = STORAGE_KEY + '=true; expires=' + expires.toUTCString() + '; path=/';
    }
  }

  if (!hasDismissed()) {
    cookieBar.classList.remove('hidden');
  }

  if (dismissBtn) {
    dismissBtn.addEventListener('click', function () {
      setDismissed();
      cookieBar.classList.add('hidden');
    });
  }
});